import { Dayjs } from "dayjs";
import { api } from "../../../config/api";
import { useQuery } from "@tanstack/react-query";
import { ReturnsFormType } from "./AddReturns";
import { returnRowType } from "./RetrunData";

export const bulkReturnsUpload = (file: File | null) => {
  return api.post(
    "/b2c/csv_order_create/",
    { file: file },
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );
};

// create returns
export const storeReturns = (data: ReturnsFormType) => {
  return api.post("/b2c/create_order/", data);
};

// Returns Listing
export const GetAllReturns = (
  startDate: Dayjs,
  endDate: Dayjs,
  page: number,
  status?: string
) => {
  const fromDate = startDate.format("YYYY-MM-DD");
  const toDate = endDate.format("YYYY-MM-DD");

  return api.get(`/b2c/return_shipment/`, {
    params: {
      from_date: fromDate,
      to_date: toDate,
      page: page,
      page_size: RETURNS_PAGE_SIZE,
      // status: "ready_to_ship",
      status: status || "",
    },
  });
};

// returns Edit page api
export const fetchDetail = (id: number) => {
  return api.get(`/b2c/shipment_details/`, {
    params: {
      id: id,
    },
  });
};

// add tag to returns
export const addReturnsTagMethod = ({
  id,
  tag,
}: {
  id: number | string;
  tag: string;
}) => {
  return api.post("/b2c/order_tag/", {
    id,
    tag,
  });
};

export const fetchRateRequest = (id: any) => {
  return api.get("/b2c/request_rate/", {
    params: {
      id: id,
    },
  });
};

export const assignReturns = ({
  id,
  quote_id,
}: {
  id: number | string;
  quote_id: number | string;
}) => {
  return api.post("/b2c/assign_shipment/", {
    id,
    quote_id,
  });
};

export const bookReturnsMethod = (arrayOfReturnsId: string[]) => {
  return api.post("/b2c/book_shipment/", arrayOfReturnsId);
};

interface scheduleDate {
  id: string | number;
  pickup_date: string;
}

export const scheduleReturns = (data: scheduleDate[]) => {
  return api.post("/b2c/schedule_pickup/", data);
};

export const downloadAwb = (id: any) => {
  return api.get("/b2c/download_awb/", {
    params: {
      id,
    },
    responseType: "blob",
  });
};

export const cancelReturns = (data: string[]) => {
  return api.post("/b2c/cancel_order/", data);
};

export const cancelShipment = (data: string[]) => {
  return api.post("/b2c/cancel_shipment/", data);
};

export const assignMultipleService = ({
  id,
  service,
  mode,
}: {
  id: string;
  service: string;
  mode: string;
}) => {
  return api.post("b2c/csv/vendor_service/", {
    id,
    service,
    mode,
  });
};

export const downloadProForma = (id: any) => {
  return api.get("b2c/pro_forma_invoice/", {
    params: {
      id,
    },
    responseType: "blob",
  });
};

export const getEditReturns = (id: string) => {
  return api.get("/b2c/edit_shipment_details/", {
    params: {
      id,
    },
  });
};

// One server page of returns for a tab. While the next page of the *same* tab loads, the
// current page stays on screen instead of flashing empty.
export const RETURNS_PAGE_SIZE = 50;

export function useReturns({
  startDate,
  endDate,
  status,
  page,
  enabled = true,
}: {
  startDate: Dayjs;
  endDate: Dayjs;
  status: string;
  page: number;
  enabled?: boolean;
}) {
  return useQuery({
    queryKey: ["returns", startDate.format("YYYY-MM-DD"), endDate.format("YYYY-MM-DD"), status, page],
    queryFn: async () => {
      const res = await GetAllReturns(startDate, endDate, page, status);
      const payload = res?.data?.data ?? {};
      return {
        rows: (payload.data ?? []) as returnRowType[],
        pageCount: Math.max(1, Number(payload.pages_count) || 1),
      };
    },
    placeholderData: (previous, previousQuery) =>
      previousQuery?.queryKey[3] === status ? previous : undefined,
    enabled,
    staleTime: 30 * 1000,
    retry: 1,
  });
}
